@switch (item.updateType) {
  @case (UpdateType.AlarmStatusChanged) {
    <div class="f-center gap-05">
      @if (item.merged.newValues?.status === AlarmStatus[0]) {
        @if (item.merged.newValues?.value) {
          <span class="inactive">{{ item.merged.newValues?.value }}</span>
        }
        <span [uiBubble]="item.merged.newValues?.tag">{{ item.merged.newValues?.tag }}</span>
        <ng-container *ngTemplateOutlet="arrow"></ng-container>
        <span>{{ item.merged.newValues?.status }}</span>
      } @else {
        <span class="inactive">{{ notAvailable }}</span>
        <ng-container *ngTemplateOutlet="arrow"></ng-container>
        <ng-container *ngTemplateOutlet="newValueTag; context: { $implicit: item }"></ng-container>
      }
    </div>
  }
  @case (UpdateType.ConfigurationUpdated) {
    <ng-container *ngTemplateOutlet="deviceUpdateView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.DeviceReinstalled) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.AssociatedDeviceUpdated) {
    <ng-container *ngTemplateOutlet="deviceUpdateView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.DeviceInactivated) {
    <div class="f-center gap-05">
      @if (item.merged.oldValues.status) {
        <ui-status-dot [status]="item.merged.oldValues.status"></ui-status-dot>
      }
      <span class="inactive">{{ item.merged.oldValues.status || notAvailable }} </span>
      <ng-container *ngTemplateOutlet="arrow"></ng-container>
      @if (item.merged.newValues.status) {
        <ui-status-dot [status]="item.merged.newValues.status"></ui-status-dot>
      }
      <span>{{ item.merged.newValues.status || notAvailable }} </span>
    </div>
  }
  @case (UpdateType.OnDemandRead) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.ReadingReceived) {
    <ng-container *ngTemplateOutlet="readingReceived; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.ValveChangeRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.ValveStatus) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.MtuFirmwareUpdateRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.MtuFirmwareUploadRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.MtuTypeFirmwareUpdateRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.DcuFirmwareUpdateRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.DcuFirmwareUploadRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.DataRecoveryRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.NicFirmwareUpdated) {
    <ng-container *ngTemplateOutlet="firmwareUpdateView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.NicConfigurationUpdated) {
    <ng-container *ngTemplateOutlet="deviceUpdateView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.NicDeviceReinstalled) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.FirmwareUpdated) {
    <ng-container *ngTemplateOutlet="firmwareUpdateView; context: { $implicit: item }"></ng-container>
  }
  @case (UpdateType.BaseStationRanConfigUpdateRequest) {
    <ng-container *ngTemplateOutlet="requestChangeView; context: { $implicit: item }"></ng-container>
  }
  @default {
    <ng-container *ngTemplateOutlet="defaultView; context: { $implicit: item }"></ng-container>
  }
}

<ng-template
  #deviceUpdateView
  let-item
>
  @if (item?.isExpanded || !item?.isExpandable) {
    @for (attr of item.attributes; track attr) {
      <div class="attribute-wrapper">
        @if ((!isArray(attr.newValue) && attr.newValue) || (isArray(attr.newValue) && attr.newValue.length)) {
          <span class="attribute mr-05">{{ attr.name }}</span>
        }
        <span
          class="inactive mr-05"
          [class.inactive]="!attr.oldValue || item?.updateType === UpdateType.ConfigurationUpdated"
        >
          {{ attr.oldValue ?? notAvailable }}
        </span>
        @if ((!isArray(attr.newValue) && attr.newValue) || (isArray(attr.newValue) && attr.newValue.length)) {
          <ng-container *ngTemplateOutlet="arrow"></ng-container>
        }
        <span
          class="ml-05"
          [class.inactive]="!attr.newValue"
        >
          {{ attr.newValue ?? notAvailable }}
        </span>
      </div>
    }
  } @else {
    <div class="attribute-wrapper gap-05">
      @for (attr of item.attributes; track attr) {
        @if ((!isArray(attr.newValue) && attr.newValue) || (isArray(attr.newValue) && attr.newValue.length)) {
          <span class="attribute">
            {{ attr.name }}
          </span>
        }
      }
    </div>
  }
</ng-template>

<ng-template
  let-item
  #requestChangeView
>
  <div class="f-center gap-05">
    @if (item.merged.oldValues?.value) {
      <span
        class="inactive"
        data-testid-old-value
      >
        {{ item.merged.oldValues?.value }}
      </span>
    } @else {
      <span class="inactive">{{ notAvailable }}</span>
    }

    <ng-container *ngTemplateOutlet="arrow"></ng-container>

    @if (item.merged.newValues?.value) {
      <span>
        {{ item.merged.newValues?.value }}
      </span>
    } @else {
      <span class="inactive">{{ notAvailable }}</span>
    }
  </div>
</ng-template>

<ng-template
  #defaultView
  let-item
>
  @if (item.merged.oldValues) {
    <div class="f-center gap-05">
      @if (item.merged.oldValues?.value) {
        <span
          class="inactive"
          data-testid-old-value
        >
          {{ item.merged.oldValues?.value }}
        </span>
      }
      <span [uiBubble]="item.merged.oldValues?.tag">{{ item.merged.oldValues?.tag }}</span>
      @if (item.merged.newValues?.value || item.merged.newValues?.tag) {
        <ng-container *ngTemplateOutlet="arrow"></ng-container>
      }
      <ng-container *ngTemplateOutlet="newValueTag; context: { $implicit: item }"></ng-container>
    </div>
  } @else {
    <span class="inactive">{{ notAvailable }}</span>
  }
</ng-template>

<ng-template
  #newValueTag
  let-item
>
  @if (item.merged.newValues?.value) {
    <span>{{ item.merged.newValues?.value }}</span>
  }
  <span [uiBubble]="item.merged.newValues?.tag">{{ item.merged.newValues?.tag }}</span>
</ng-template>

<ng-template #arrow>
  <ui-icon
    [name]="iconName"
    [color]="arrowColor"
  ></ui-icon>
</ng-template>

<ng-template
  let-item
  #readingReceived
>
  <div class="f-center gap-05">
    @if (item.merged.oldValues?.value) {
      <span
        class="inactive"
        data-testid-old-value
      >
        {{ item.merged.oldValues?.value }}
      </span>
    }

    @if (item.merged.newValues?.value) {
      <ng-container *ngTemplateOutlet="arrow"></ng-container>

      <span>
        {{ item.merged.newValues?.value }}
      </span>
    } @else {
      <span class="inactive">{{ notAvailable }}</span>
    }
  </div>
</ng-template>

<ng-template
  #firmwareUpdateView
  let-item
>
  @if (item?.isExpanded || !item?.isExpandable) {
    @if (item.merged.oldValues) {
      <div class="attribute-wrapper">
        @if (item.merged.oldValues?.value || item.merged.oldValues?.tag) {
          <span class="attribute mr-05">{{ item.merged.oldValues?.tag }}</span>
        }
        <span
          class="inactive mr-05"
          [class.inactive]="!item.merged.oldValues?.value"
        >
          {{ item.merged.oldValues?.value ?? notAvailable }}
        </span>
        @if (item.merged.newValues?.value || item.merged.newValues?.tag) {
          <ng-container *ngTemplateOutlet="arrow"></ng-container>
        }
        <span
          class="ml-05"
          [class.inactive]="!item.merged.newValues?.value"
        >
          {{ item.merged.newValues?.value ?? notAvailable }}
        </span>
      </div>
    }

    @for (attr of item.attributes; track attr) {
      <div class="attribute-wrapper">
        @if ((!isArray(attr.newValue) && attr.newValue) || (isArray(attr.newValue) && attr.newValue.length)) {
          <span class="attribute mr-05">{{ attr.name }}</span>
        }
        <span
          class="inactive mr-05"
          [class.inactive]="!attr.oldValue"
        >
          {{ attr.oldValue ?? notAvailable }}
        </span>
        @if ((!isArray(attr.newValue) && attr.newValue) || (isArray(attr.newValue) && attr.newValue.length)) {
          <ng-container *ngTemplateOutlet="arrow"></ng-container>
        }
        <span
          class="ml-05"
          [class.inactive]="!attr.newValue"
        >
          {{ attr.newValue ?? notAvailable }}
        </span>
      </div>
    }
  } @else {
    <div class="attribute-wrapper gap-05">
      @if (item.merged.newValues?.value || item.merged.newValues?.tag) {
        <span class="attribute">
          {{ item.merged.newValues?.tag }}
        </span>
      }
      @for (attr of item.attributes; track attr) {
        @if ((!isArray(attr.newValue) && attr.newValue) || (isArray(attr.newValue) && attr.newValue.length)) {
          <span class="attribute">
            {{ attr.name }}
          </span>
        }
      }
    </div>
  }
</ng-template>
